import { environment } from '../../../../../environments/environment';

export class SectoresEnvironmentDefinition {
  public appName = environment.appName;
  
  public sectorName = environment.features.sectorName;

  public sectoresName = environment.features.sectoresName;

  public applicationType = environment.features.applicationType;
  
  public serverUrl = environment.serverUrl;

  public hasClients = environment.features.hasClients;
  
  public fincaName = environment.features.fincaName;
  
  public fincasName = environment.features.fincasName;
  
  public showSectorPlantas = environment.features.showSectorPlantas;

  public showPartida = environment.features.showPartida;
  
  public canAddSectores = environment.features.canAddSectores;
      
  public canEditSectores = environment.features.canEditSectores;
      
  public canDeleteSectores = environment.features.canDeleteSectores;

  public textoSuperficie = environment.features.textoSuperficie;
}// class;